import TermsOfUse from "../../components/infoPages/termsOfUse"

const TermsOfUsePage = ({authUser}) => {
  return (
    <div>
       <TermsOfUse authUser={authUser} />
    </div>
  )
}

export default TermsOfUsePage;